import { FC } from "react";
import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utility";
import { DashedSeparatorIcon } from "src/assets/Icons";
import type { PriceBreakdown } from "src/Modules/Hotels/hooks/usePriceBreakdown";

const TotalAmount: FC<{ price: PriceBreakdown; isPaymentStep?: boolean }> = ({ price, isPaymentStep = false }) => {
  const { t } = useTranslation();
  const label = isPaymentStep ? t("Flights.details.summary.amountDueCash") : t("Flights.details.summary.totalAmount");

  return (
    <div className="flex flex-col gap-4 pt-0.5 p-2">
      <span className="text-font-subtle text-xs font-bold uppercase leading-4 tracking-wider">{label}</span>
      <div className="flex items-center gap-4">
        <div className="flex flex-col gap-2">
          <span className="whitespace-nowrap text-xl font-bold leading-8 tracking-tight text-font-default">
            {formatNumber(price.cashToPay)} {price.currency}
          </span>
          {price.totalOriginalFare != null && price.originalCurrency && (
            <span className="text-font-subtle whitespace-nowrap font-medium">
              {formatNumber(price.totalOriginalFare)} {price.originalCurrency}
            </span>
          )}
        </div>
        <div className="border-border-disabled flex h-7 w-7 shrink-0 flex-col items-center justify-center -space-y-1 rounded-full border border-dashed bg-background-default">
          <DashedSeparatorIcon className="h-2.5 w-4 text-font-default" />
          <DashedSeparatorIcon className="h-2.5 w-4 text-font-default" />
        </div>
        <span className="text-font-active whitespace-nowrap text-xl font-bold leading-8 tracking-tight">
          {formatNumber(price.pointsToPay)} {t("Flights.details.summary.pts")}
        </span>
      </div>
    </div>
  );
};

export default TotalAmount;
